import { $$, $ } from '../utils/dom.js';
import { setHtmlClass } from '../utils/html-class.js';

const BOOK_TABLE_OPEN_CLASS = 'book-table-open';

const FOCUSABLE_SELECTOR =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

function getFocusableElements(container) {
  return $$(FOCUSABLE_SELECTOR, container).filter((element) => !element.disabled);
}

export function initBookTablePanel() {
  const panel = $('[data-book-table-panel]');
  const closeBtn = $('[data-book-table-close]', panel);
  const openBtns = $$('[data-book-table-open]');

  if (!panel || !closeBtn) {
    return () => {};
  }

  let removeKeydown = null;
  let previousFocus = null;

  const close = () => {
    if (panel.getAttribute('data-state') !== 'open') {
      return;
    }

    if (removeKeydown) {
      removeKeydown();
      removeKeydown = null;
    }

    panel.setAttribute('data-state', 'closed');
    panel.setAttribute('hidden', '');
    setHtmlClass(BOOK_TABLE_OPEN_CLASS, false);

    openBtns.forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }

    previousFocus = null;
  };

  const open = (trigger) => {
    previousFocus = document.activeElement;
    panel.removeAttribute('hidden');
    panel.setAttribute('data-state', 'open');
    setHtmlClass(BOOK_TABLE_OPEN_CLASS, true);

    openBtns.forEach((btn) => {
      btn.setAttribute('aria-expanded', btn === trigger ? 'true' : 'false');
    });

    const onKeydown = (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      const focusable = getFocusableElements(panel);
      if (!focusable.length) {
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', onKeydown);
    removeKeydown = () => {
      document.removeEventListener('keydown', onKeydown);
    };

    closeBtn.focus();
  };

  const onOpen = (event) => {
    event.preventDefault();
    open(event.currentTarget);
  };

  const onClose = () => {
    close();
  };

  const onBackdrop = (event) => {
    if (event.target === panel) {
      close();
    }
  };

  openBtns.forEach((btn) => {
    btn.addEventListener('click', onOpen);
  });
  closeBtn.addEventListener('click', onClose);
  panel.addEventListener('click', onBackdrop);

  return () => {
    close();
    openBtns.forEach((btn) => {
      btn.removeEventListener('click', onOpen);
    });
    closeBtn.removeEventListener('click', onClose);
    panel.removeEventListener('click', onBackdrop);
  };
}
